module.exports = __webpack_public_path__ + "static/media/xs4all-bw.c1094983.jpg";